import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Suspense as _Suspense, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-627e19a6"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "staking-container" };
const _hoisted_2 = { key: 0 };
const _hoisted_3 = { class: "desc" };
const _hoisted_4 = {
    key: 0,
    class: "pos-relative"
};
const _hoisted_5 = { key: 1 };
const _hoisted_6 = { key: 1 };
const _hoisted_7 = { class: "desc" };
const _hoisted_8 = {
    key: 0,
    class: "pos-relative"
};
const _hoisted_9 = { key: 1 };
const _hoisted_10 = { key: 2 };
const _hoisted_11 = {
    key: 0,
    class: "pos-relative"
};
const _hoisted_12 = { key: 1 };
const _hoisted_13 = { key: 3 };
const _hoisted_14 = { key: 4 };
import { onErrorCaptured, ref } from 'vue';
import { useMessage } from '@/const/messages';
import Stepper from '@/components/organisms/main/staking/register/Stepper.vue';
import StakingCryptoChoiceList from '@/components/organisms/main/staking/register/StakingCryptoChoiceList.vue';
import StakingAmount from '@/components/organisms/main/staking/register/StakingAmount.vue';
import StakingConfirm from '@/components/organisms/main/staking/register/StakingConfirm.vue';
import StakingComplete from '@/components/organisms/main/staking/register/StakingComplete.vue';
import Loading from '@/materials/molecules/Loading.vue';
import StakingPlanList from '@/components/organisms/main/staking/register/StakingPlanList.vue';
import RefreshWarn from '@/materials/atoms/RefreshWarn.vue';
/* constant  declaration */
export default /*#__PURE__*/ _defineComponent({
    props: {
        userInfo: null,
        isAuth: { type: Boolean }
    },
    emits: ["registerDone"],
    setup(__props, { emit }) {
        const props = __props;
        const selectedPlan = ref();
        const isError = ref(false);
        const { PLANCARD, STEPPERS, CHOICECARD, format } = useMessage();
        const selectedCurrency = ref();
        const stakeAmount = ref(0);
        const decimalPlace = ref(0); //decimalPlace
        const interestAmount = ref(0);
        const stakePlan = ref();
        const STATUS = {
            SELECT_CURRENCY: 1,
            SELECT_PLAN: 2,
            INPUT_AMOUNT: 3,
            CONFIRMATION: 4,
            COMPLETE: 5,
        };
        const selectedId = ref(STATUS.SELECT_CURRENCY);
        const STEPS_MSG = [
            {
                id: STATUS.SELECT_CURRENCY,
                label: STEPPERS.CURRENCY_SELECT,
            },
            {
                id: STATUS.SELECT_PLAN,
                label: STEPPERS.PLAN_SELECT,
            },
            {
                id: STATUS.INPUT_AMOUNT,
                label: STEPPERS.AMOUNT_INPUT,
            },
            {
                id: STATUS.CONFIRMATION,
                label: STEPPERS.CONFIRM,
            },
            {
                id: STATUS.COMPLETE,
                label: STEPPERS.COMPLETE,
            },
        ];
        /* function  declaration */
        const moveBackStepperByReturnButton = () => {
            if (selectedId.value > 1 && selectedId.value < 6) {
                selectedId.value--;
            }
        };
        const moveBackStepperByDirectClick = (id) => {
            if (id < STATUS.INPUT_AMOUNT) {
                stakeAmount.value = 0;
            }
            if (id < selectedId.value) {
                selectedId.value = id;
            }
        };
        const moveToNextStepper = () => {
            selectedId.value++;
        };
        const setSelectedCurrency = (value) => {
            moveToNextStepper();
            selectedCurrency.value = value;
        };
        const onClickPlan = (value) => {
            moveToNextStepper();
            selectedPlan.value = value;
        };
        const onClickStakingAmount = (amount, plan, dp) => {
            moveToNextStepper();
            decimalPlace.value = dp;
            stakeAmount.value = amount;
            stakePlan.value = plan;
        };
        const onClickStakingConfirm = (amount) => {
            moveToNextStepper();
            interestAmount.value = amount;
        };
        const onClickStakingComplete = (value) => {
            emit('registerDone', value);
        };
        /* LIFECYCLE declaration */
        onErrorCaptured(() => {
            isError.value = true;
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(Stepper, {
                    steps: STEPS_MSG,
                    "is-show-button": false,
                    "selected-id": selectedId.value,
                    onUpdateStepperIdByBtn: moveBackStepperByReturnButton,
                    onUpdateStepperIdByDirectClick: moveBackStepperByDirectClick
                }, null, 8, ["selected-id"]),
                (selectedId.value === STATUS.SELECT_CURRENCY)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                        _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(format)(_unref(CHOICECARD).WHAT)), 1),
                        (!isError.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                (_openBlock(), _createBlock(_Suspense, null, {
                                    default: _withCtx(() => [
                                        _createVNode(StakingCryptoChoiceList, {
                                            "is-auth": __props.isAuth,
                                            class: "list_currencies",
                                            onSelectCurrency: setSelectedCurrency
                                        }, null, 8, ["is-auth"])
                                    ]),
                                    fallback: _withCtx(() => [
                                        _createVNode(Loading)
                                    ]),
                                    _: 1
                                }))
                            ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                                _createVNode(RefreshWarn)
                            ]))
                    ]))
                    : _createCommentVNode("", true),
                (selectedId.value === STATUS.SELECT_PLAN)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                        _createElementVNode("div", _hoisted_7, _toDisplayString(_unref(format)(_unref(PLANCARD).WHAT)), 1),
                        (!isError.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                (_openBlock(), _createBlock(_Suspense, null, {
                                    default: _withCtx(() => [
                                        _createVNode(StakingPlanList, {
                                            "is-auth": __props.isAuth,
                                            "crypto-info": selectedCurrency.value,
                                            onClick: onClickPlan
                                        }, null, 8, ["is-auth", "crypto-info"])
                                    ]),
                                    fallback: _withCtx(() => [
                                        _createVNode(Loading)
                                    ]),
                                    _: 1
                                }))
                            ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                _createVNode(RefreshWarn)
                            ]))
                    ]))
                    : _createCommentVNode("", true),
                (selectedId.value === STATUS.INPUT_AMOUNT)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                        (!isError.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                (_openBlock(), _createBlock(_Suspense, null, {
                                    default: _withCtx(() => [
                                        _createVNode(StakingAmount, {
                                            "crypto-name": selectedCurrency.value.cryptoName,
                                            "crypto-id": selectedCurrency.value.id,
                                            term: selectedPlan.value.term,
                                            "stake-amount": stakeAmount.value,
                                            "is-auth": __props.isAuth,
                                            onOnConfirm: onClickStakingAmount
                                        }, null, 8, ["crypto-name", "crypto-id", "term", "stake-amount", "is-auth"])
                                    ]),
                                    fallback: _withCtx(() => [
                                        _createVNode(Loading)
                                    ]),
                                    _: 1
                                }))
                            ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                _createVNode(RefreshWarn)
                            ]))
                    ]))
                    : _createCommentVNode("", true),
                (selectedId.value === STATUS.CONFIRMATION)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                        _createVNode(StakingConfirm, {
                            term: selectedPlan.value.term,
                            "stake-amount": stakeAmount.value,
                            "crypto-name": selectedCurrency.value.cryptoName,
                            plan: stakePlan.value,
                            "decimal-place": decimalPlace.value,
                            "user-info": props.userInfo,
                            onOnStakeSuccess: onClickStakingConfirm
                        }, null, 8, ["term", "stake-amount", "crypto-name", "plan", "decimal-place", "user-info"])
                    ]))
                    : _createCommentVNode("", true),
                (selectedId.value === STATUS.COMPLETE)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                        _createVNode(StakingComplete, {
                            term: selectedPlan.value.term,
                            amount: stakeAmount.value,
                            "crypto-name": selectedCurrency.value.cryptoName,
                            "interest-rate": stakePlan.value.annualInterestRate,
                            "interest-amount": interestAmount.value,
                            "user-info": props.userInfo,
                            onOnButtonClick: _cache[0] || (_cache[0] = ($event) => (onClickStakingComplete('dashboard')))
                        }, null, 8, ["term", "amount", "crypto-name", "interest-rate", "interest-amount", "user-info"])
                    ]))
                    : _createCommentVNode("", true)
            ]));
        };
    }
});
